export const environment = {
  api_URL: 'https://beta-jbn-fds-api.moba-cloud.com/',
  production: true,
  LanguageCode: 'en',
  Type: 'Web',
  googleApiKey: 'AIzaSyA8kbmaC-aeFOLu2VQt-niDpiDSqtyYkSw',
  PublicKey: 'd2ViLWpibmZkc0BNb2JhMjAyNQ==',
  statusCode: {
    SUCCESS: 200,
    LOGOUT: 203,
    INVALID: 201,
  },
  favSiteId: 8,
  mapId: 'a8c84e93d4882416',
   version: '1.0',
  mode: 'development',
    ReportImagePath: 'https://beta-jbn-fds-api.moba-cloud.com/images/dispense_odometer/',
};
